export default "__VITE_ASSET__B5WAGDq0__"